export interface ResponseAuth {
  nombre:             string;
  apellido:           string;
  usuario:            string;
  companyId:          number;
  companyName:        string;
  userId:             number;
  token:              string;
  type:               string;
  expirationDuration: number;
  roles:              string[];
  userIp:             string;
}
export interface UserInfo {
  nombre:                 string;
  apellido:               string;
  usuario:                string;
  roles:                  string[];
  userId:       number;
  userIp:       string;
  companyId:  number;
  companyName: string;
}
